import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { Order } from '../models/Order';
import { environment } from '../../environments/environment';
import { GatewayOrder } from '../models/GatewayOrder';
import CustomerService from './CustomerService';

@Injectable()
export default class OrderService {
  baseUrl = `${environment.backend.baseUrl}${environment.backend.apiUrl}/`;
  constructor(
    private http: HttpClient,
    private customerService: CustomerService
  ) {
  }

  // Removed getOrders(): list now comes from Gateway via backend only

  getOrdersByMe(): Observable<Order[]> {
    return this.http.get<Order[]>(this.baseUrl + `Orders/byMe`);
  }

  getOrdersByCustomerNo(customerNo: number): Observable<Order[]> {
    return this.http.get<Order[]>(this.baseUrl + `Orders/byCustomerNo/${customerNo}`);
  }

  getPendingOrders(): Observable<Order[]> {
    return this.http.get<Order[]>(this.baseUrl + `Orders/pending`);
  }

  getReflexOrders(filters?: { fromDate?: string; toDate?: string; status?: string; page?: number; pageSize?: number }): Observable<GatewayOrder[]> {
    const params: string[] = [];
    if (filters?.fromDate) params.push(`fromDate=${encodeURIComponent(filters.fromDate)}`);
    if (filters?.toDate) params.push(`toDate=${encodeURIComponent(filters.toDate)}`);
    if (filters?.status) params.push(`status=${encodeURIComponent(filters.status)}`);
    if (filters?.page != null) params.push(`page=${filters.page}`);
    if (filters?.pageSize != null) params.push(`pageSize=${filters.pageSize}`);
    const qs = params.length ? `?${params.join('&')}` : '';
    return this.http.get<GatewayOrder[]>(this.baseUrl + 'Orders/gateway' + qs);
  }

  getOrderById(id: number): Observable<Order> {
    return this.http.get<Order>(this.baseUrl + 'Orders/' + id);
  }

  getReflexOrderById(id: string): Observable<GatewayOrder> {
    return this.http.get<GatewayOrder>(this.baseUrl + 'Orders/gateway/' + id);
  }

  useCoins(
    userName: string,
    reflexId: string,
    coins: number
  ): Observable<Order> {
    return this.http.post<Order>(
      this.baseUrl + 'Orders/useCoins',
      { userName, reflexId: parseInt(reflexId), coins }
    );
  }

  changeOrderStatus(orderId: number, action: 'approve' | 'decline'): Observable<Order> {
    return this.http.post<Order>(
      this.baseUrl + `Orders/${orderId}/${action}`,
      {}
    );
  }

  getOrderHistory(orderNo: string): Observable<any[]> {
    return this.http.get<any[]>(this.baseUrl + `Orders/gateway/orderHistory/${orderNo}`);
  }

  triggerManualOrderProcessing(reflexCustomerNo: number): Observable<void> {
    return this.http.post<void>(
      this.baseUrl + `OrderProcessing/trigger/${reflexCustomerNo}`,
      {}
    );
  }
}